<bn-loading-overlay></bn-loading-overlay>
<h5>Habilitação Alternativa</h5>
<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            <div *ngIf="podeCadastrarHabilitacao" class="col-auto">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/habilitacao/alternativa/novo']"
                  ngbTooltip="Selecione esta opção para incluir Habilitação Alternativa."><i class="fa fa-file-signature">
                  </i> Cadastrar Habilitação
                </button>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>
            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false)" (click)="buscar(false)"
                    [disabled]="!pesquisaForm.valid" >Pesquisar
                </button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="bn-form-group col-md-4">
                <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
                <ng-select
                  id="agenteFinanceiro"
                  [items]="agentesFinanceiros"
                  bindLabel="sigla"
                  [multiple]="false"
                  [readonly]="naoPodeConsultarTodos"
                  [clearable]="true"
                  [clearOnBackspace]="true"
                  formControlName="agenteFinanceiro"
                  [searchable]="true"
                  bindValue="id"
                  placeholder="Todos"
                  class="auto-grow">
                  <ng-template ng-label-tmp let-item="item">
                    {{ item.sigla }}
                  </ng-template>
                </ng-select>
            </div>
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="dataInicioVigencia" >Data início vigência:</label>
                <bn-datepicker
                    name="dataInicioVigencia"
                    idInput="dataInicioVigencia"
                    ngDefaultControl
                    formControlName="dataInicioVigencia">
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-3">
                <label class="form-label" for="dataFimVigencia">Data fim vigência: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Considerar a data máxima de validade"></i>
                </label>
                <bn-datepicker
                    name="dataFimVigencia"
                    idInput="dataFimVigencia"
                    ngDefaultControl
                    formControlName="dataFimVigencia">
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label" for="situacao">Situação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Exibe a situação do Agente Financeiro na habilitação alternativa"></i></label>
                <select class="form-select" name="situacao" id="situacao" ngDefaultControl formControlName="situacao">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let situacao of situacoes"
                        [ngValue]="situacao">{{ situacao.label }}
                    </option>
                </select>
            </div>
        </div>
    </form>
</div>
<app-habilitacao-alternativa-listagem
    [msgSemResultado]="msgSemResultado"
    [dataHoraResultado]="dataHoraResultado"
    [habilitacoes]="habilitacoes"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    [podeCadastrarHabilitacao]="podeCadastrarHabilitacao"
    (aoMudarPagina)="mudancaPagina($event)"
    (exportarHabilitacoes)="exportarHabilitacoes()"
    (excluirHabilitacoes)="excluir($event)">
</app-habilitacao-alternativa-listagem>
